import * as XLSX from "xlsx";

const exportFormDIToExcel = (data, fileName,t) => {

  const formatDate = (dateValue) => {
    if (!dateValue) return "";
    const date = new Date(dateValue);
    return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
  };

  // Preparamos filas (una por cada LER; si no hay LER, una fila vacía)
  const entradasData = data.map(data => [
      data.preiddoc_sheet || "",
      data.sufiddoc_sheet || 0,
      data.number_dt || "",
      formatDate(data.date_sheet) || "",
      data.widevalidity? (formatDate(data.end_date_sheet) || ""):"",
 
      data.opt_tras_documentid || "",
      data.opt_tras_tradename || "",
      data.opt_tras_nima || "",
  
      data.ori_tras_documentid || "",
      data.ori_tras_tradename || "",
      data.ori_tras_roadtype_name || "",
      data.ori_tras_street || "",
      data.ori_tras_province_name || "", 
      data.ori_tras_postalcode_code || "",
      data.ori_tras_postalcode_name || "",
      data.ori_tras_community_name || "",
      data.ori_tras_nima || "", 

      data.dest_tras_documentid || "",
      data.dest_tras_tradename || "",
      data.dest_tras_roadtype_name || "",
      data.dest_tras_street || "",
      data.dest_tras_province_name || "", 
      data.dest_tras_postalcode_code || "",
      data.dest_tras_postalcode_name || "",
      data.dest_tras_community_name || "",
      data.dest_tras_nima || "", 

      data.rel_trans_documentid || "",
      data.rel_trans_tradename || "",
      data.rel_trans_roadtype_name || "",
      data.rel_trans_street || "",
      data.rel_trans_province_name || "", 
      data.rel_trans_postalcode_code || "",
      data.rel_trans_postalcode_name || "",
      data.rel_trans_community_name || "",
      data.rel_trans_nima || "", 
      data.rel_trans_licenseplate || "",  

      data.codeler_code || "",
      data.codeler_namees || "", 
      data.amount || 0,
      formatDate(data.deliver_date)|| "",
      data.delivery_quantity || 0,
      t(data.accept) || "",
      formatDate(data.date_accepted) || "",
      formatDate(data.date_refund) || "", 
      data.reason_refund || "",
      data.action_refund || "",
      data.observations || ""
 ]);
 
  const headers = [
    "Nº FORMULARIO",
    "SUFIO",
    "Nº DE NOTIFICACIÓN PREVIO", 
    "FECHA INICIO TRASLADO", 
    "FECHA FIN TRASLADO", 

    "OPERADOR Nº DOCUMENTO", 
    "OPERADOR RAZÓN SOCIAL", 
    "OPERADOR NIMA", 

    "ORIGEN Nº DOCUMENTO", 
    "ORIGEN RAZÓN SOCIAL", 
    "ORIGEN TIPO DE  VÍA", 
    "ORIGEN DIRECCIÓN",  
    "ORIGEN PROVINCIA", 
    "ORIGEN CÓDIGO POSTAL", 
    "ORIGEN LOCALIDAD",
    "ORIGEN COMINIDAD",
    "ORIGEN NIMA",
    
    "DESTINO Nº DOCUMENTO",
    "DESTINO RAZÓN SOCIAL",
    "DESTINO TIPO DE  VÍA",
    "DESTINO DIRECCIÓN", 
    "DESTINO PROVINCIA",  
    "DESTINO CÓDIGO POSTAL",  
    "DESTINO LOCALIDAD", 
    "DESTINO COMINIDAD",  
    "DESTINO NIMA", 
   
    "TRANSPORTISTA Nº DOCUMENTO", 
    "TRANSPORTISTA RAZÓN SOCIAL",  
    "TRANSPORTISTA TIPO DE  VÍA",  
    "TRANSPORTISTA DIRECCIÓN",  
    "TRANSPORTISTA PROVINCIA",  
    "TRANSPORTISTA CÓDIGO POSTAL", 
    "TRANSPORTISTA LOCALIDAD", 
    "TRANSPORTISTA COMINIDAD",  
    "TRANSPORTISTA NIMA", 
    "TRANSPORTISTA MATRÍCULA",  
   
    "CÓDIGO LER",  
    "DESCRIPCIÓN LER",  
    "CANTIDAD ESTIMADA",  
    "FECHA ENTREGA", 
    "CANTIDAD ACEPTADA", 
    "ACEPTACIÓN",  
    "FECHA ACEPTACIÓN", 
    "FECHA DEVOLUCIÓN", 
    "MOTIVO RECHAZO", 
    "ACCIÓN EN CASO DE RECHAZO",
    "OBSERVACIONES"
   ];

  const worksheet = XLSX.utils.aoa_to_sheet([headers, ...entradasData]);

  // --- Filtros automáticos en la fila de cabecera ---
  worksheet['!autofilter'] = { ref: XLSX.utils.encode_range({ s: { c: 0, r: 0 }, e: { c: headers.length - 1, r: 0 } }) };

  // --- Estilo cabeceras: azul clarito, negrita, centradas, con bordes ---
  const headerStyle = {
    fill: { fgColor: { rgb: "CCE5FF" } }, // azul clarito
    font: { bold: true },
    alignment: { horizontal: "center", vertical: "center", wrapText: true },
    border: {
      top: { style: "thin", color: { rgb: "999999" } },
      bottom: { style: "thin", color: { rgb: "999999" } },
      left: { style: "thin", color: { rgb: "999999" } },
      right: { style: "thin", color: { rgb: "999999" } },
    },
  };

  headers.forEach((_, colIndex) => {
    const cellAddress = XLSX.utils.encode_cell({ c: colIndex, r: 0 });
    if (!worksheet[cellAddress]) return;
    worksheet[cellAddress].s = headerStyle;
  });

  // --- Ajuste automático del ancho de las columnas ---
  const colWidths = headers.map(() => ({ wch: 20 }));
  worksheet["!cols"] = colWidths;

  // --- Generación del libro y descarga ---
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "FORMULARIOS");

  const safeFileName = fileName.endsWith(".xlsx") ? fileName : `${fileName}.xlsx`;
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array", cellStyles: true });
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });

  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = safeFileName;
  a.click();
  window.URL.revokeObjectURL(url);
};

export default exportFormDIToExcel;
